import { Box, Grid } from '@mui/material';

import { FHPageLink } from '../../../components/base';
import PageContainer from '../../../components/layout/PageContainer';
import {
  ProviderAssignedClients,
  ProviderBasicInfo,
  ProviderClinicalStatusUpdate,
  ProviderDetailsHeader,
  ProviderOtherInfo,
  ProviderPayorCredentials,
  ProviderQuestionnaireManagement,
  ProviderReviewerBcba,
  ProviderSsn,
} from './components';
import { useProviderDetailsPage } from './hooks';

function ProviderDetailsPage() {
  const { showClinicalStatusSection, showQuestionnaireManagement, showSsnSection } =
    useProviderDetailsPage();

  return (
    <PageContainer>
      <Box sx={{ mt: 3 }} textAlign="left">
        <FHPageLink to="/admin" label="Admin Home" />
        <ProviderDetailsHeader />
        <hr></hr>
        <Box mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={showClinicalStatusSection ? 4 : 6} mt={2}>
              <ProviderBasicInfo />
            </Grid>
            <Grid item xs={12} lg={showClinicalStatusSection ? 4 : 6} mt={2}>
              <ProviderOtherInfo />
            </Grid>
            {showClinicalStatusSection && (
              <Grid item xs={12} lg={4} mt={2}>
                <ProviderClinicalStatusUpdate />
              </Grid>
            )}
          </Grid>
          {showSsnSection && (
            <Box mt={4}>
              <ProviderSsn />
            </Box>
          )}
          <Box mt={4}>
            <ProviderReviewerBcba />
          </Box>
          <Box mt={4}>
            <ProviderAssignedClients />
          </Box>
          <ProviderPayorCredentials />
          {showQuestionnaireManagement && <ProviderQuestionnaireManagement />}
        </Box>
      </Box>
    </PageContainer>
  );
}

export default ProviderDetailsPage;
